import Vue from 'vue'
import mobileDetect from "mobile-device-detect";
Vue.mixin({
    data() {
        return {
          notAllowedCharacters: '[`~,<>;:"!?%&¤#/\\[]|{}()+]' + "'",      
          GetMaxTotalBytesAllowedToSendSefosMessage: 200,
          GetMaxTotalBytesAllowedToSendSDKMessage: 30,
          GetMaxTotalBytesAllowedToSendFAXMessage: 15,
          GetMaxTotalBytesAllowedToSendFilestorage: 200,
          currentDevice: mobileDetect
        };
    },
    methods: {
      IsMessage(type) {
        if (
          type == "message" ||
          type == "response" ||
          type == "creator-response" ||
          type == "link-response" ||
          type == "creator-link-response" ||
          type == "fax-message" ||
          type == "sdk-message"
        ) {
          return true;
        } else {
          return false;
        }
      },
      IsExternalMessage(type) {
        if (
          type == "fax-message" ||
          type == "sdk-message"
        ) {
          return true;
        } else {
          return false;
        }
      },
      IsMeeting(type) {
        if (
          type == "teams-meeting" ||
          type == "jitsi-meeting" ||
          type == "jitsi-secure-meeting" ||
          type == "nuiteq-meeting"
        ) {
          return true;
        } else {
          return false;
        }
      },
      IsSefosMessage(type) {
        if (
          type == "message" ||
          type == "response" ||
          type == "creator-response" ||
          type == "link-response" ||
          type == "creator-link-response"
        ) {
          return true;
        } else {
          return false;
        }
      },
      validatePhone(phone)
      {
        var reg_phone = /^\+(?:[0-9] ?){6,14}[0-9]$/;
        //let reg_phone = /^\+[1-9]\d{1,14}$/;
        return reg_phone.test(phone);
      },
      validateEmail(email) {
        let reg_email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
        let validation = reg_email.test(email);
        return validation;
      },
      validatePNum(sPNum) {
        sPNum = sPNum.replace("-", "");
        var numbers = sPNum.match(/^(\d)(\d)(\d)(\d)(\d)(\d)(\d)(\d)(\d)(\d)(\d)(\d)$/);
        var checkSum = 0;
        if (!this.isDate(sPNum.substring(0, 4), sPNum.substring(4, 6), sPNum.substring(6, 8))) {
          return false;
        }
        if (numbers == null) { return false; }
        var n;
        for (var i = 3; i <= 12; i++) {
          n = parseInt(numbers[i]);
          if (i % 2 == 0) {
            checkSum += n;
          } else {
            checkSum += (n * 2) % 9 + Math.floor(n / 9) * 9
          }
        }
        if (checkSum % 10 == 0) { return true; }
        return false;
      },
      validateLettersAndNumbers(string)
      {
        if (/[`~,<>;':"!?%&¤#/[\]|{}()+]/.test(string)) {
          return false;
        }else{
          return true;
        }
      },
      isLettersAndNumbers(e) {
        let char = String.fromCharCode(e.keyCode); 
        if (/[`~,<>;':"!?%&¤#/[\]|{}()+]/.test(char)) {
          e.preventDefault();
        }
      },
      mbDescription(mb) {
        if (mb === 0) return mb;
        if(mb >= 1000){
          return (mb/1000) + "GB";
        }
        return mb + "MB";
      },
      bytesToSize(bytes, decimals = 2) {
          if (bytes === 0) return "0";
          const k = 1024;
          const dm = decimals < 0 ? 0 : decimals;
          const sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
          const i = Math.floor(Math.log(bytes) / Math.log(k));
          return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
      },
      downloadBlob(blob, name) {     
          //console.log(name);
          if(this.currentDevice.isMobile && this.currentDevice.isChrome && this.currentDevice.isIOS)
          {
              //isChromeIos
              var reader = new FileReader();
              reader.onloadend = function() {
              window.open(reader.result, "_self");
              }
              reader.readAsDataURL(blob);
          }else{
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                  window.navigator.msSaveOrOpenBlob(blob, name);
              } else {    
                  //console.log(name);
                  let $link = document.createElement("a");
                  let url = window.URL.createObjectURL(blob);
                  $link.setAttribute("target", "_blank");
                  $link.setAttribute("href", url);
                  $link.setAttribute("download", name);
                  $link.style.visibility = "hidden";
                  document.body.appendChild($link);
                  $link.click();
                  document.body.removeChild($link);
              }
          }
      },
      getYear(y) { 
        return (y < 1000) ? y + 1900 : y;
      },
      isDate(year, month, day)
      {
        month = month - 1;
        var tmpDate = new Date(year,month,day);
        if ( (this.getYear(tmpDate.getYear()) == year) &&
        (month == tmpDate.getMonth()) &&
        (day == tmpDate.getDate()) )
          return true;
        else
          return false;
      },
      checkValidVersion(version) {
        //console.log("this.user.version: " + this.user.version);
        //console.log("version:" + version);
        var compare = this.$compare(this.user.version, version);
        //console.log("compare:" + compare);
        //console.log("checkValidVersion:" +  (compare == 0 || compare == 1));
        return  (compare == 0 || compare == 1);
      },
      FormatDateTime(datetime) {
        return this.$luxonDateTime.fromISO(datetime).toLocaleString(this.$luxonDateTime.DATETIME_MED)
      },
      FormatDateTimeRelative(datetime) {
        return this.$luxonDateTime.fromISO(datetime).toRelative()
      },
      FormatDateTimeSimple(datetime){
        return this.$luxonDateTime.fromISO(datetime).toLocaleString(this.$luxonDateTime.TIME_SIMPLE);
      },
      CurrentTime(){
        return new this.$luxonDateTime.utc().set({
          seconds: 0,
          milliseconds: 0,
        });
      },
      TomorrowTime()
      {
        return new this.$luxonDateTime.utc().set({ seconds: 0, milliseconds: 0, }).plus({ days: 1 }).toISO();
      },
      Truncate(information, length)
      {
        if (information.length > length) {
          return information.substr(0, length - 2) + "..";
        } else {
          return information;
        }
      },
    },
    computed: {
      sefos_locale(){
        return this.$i18n.locale;
      },
      locales(){
        return this.$store.state.lang.locales;
      },
      sefos_locales() {
        return this.$store.state.lang.locales;
      },
      user(){
        return this.$store.state.user;
      },     
      userHasLoaded(){
        return this.user.information && this.user.version != "";
      },
      teams() {
        return this.$store.state.teams;
      }
    }
  })